var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"add-hot-wrapper",on:{"click":_vm.itemClick}},[_c('i',{staticClass:"add-icon"})])}
var staticRenderFns = []

export { render, staticRenderFns }